module.exports = __webpack_public_path__ + "static/media/user-cog.c9b55a06.svg";